export function centerAmount(calculatedAmount) {
    var length = (calculatedAmount === null || calculatedAmount === void 0 ? void 0 : calculatedAmount.toString().length) || 0;
    if (length === 2) {
        return 'text-[60px] -translate-x-[40px]';
    }
    if (length >= 10) {
        return 'text-[20px] -translate-x-[-40px]';
    }
    if (length >= 9) {
        return 'text-[24px] -translate-x-[-40px]';
    }
    if (length >= 8) {
        return 'text-[28px] -translate-x-[-40px]';
    }
    if (length >= 7) {
        return 'text-[32px] -translate-x-[-40px]';
    }
    if (length >= 6) {
        return 'text-[38px] -translate-x-[-30px]';
    }
    if (length >= 5) {
        return 'text-[42px] -translate-x-[-20px]';
    }
    if (length >= 4) {
        return 'text-[42px] -translate-x-[-10px]';
    }
    if (length >= 3) {
        return 'text-[42px] -translate-x-[10px]';
    }
    return 'text-[60px] -translate-x-[40px]'; // Default for no value or single-digit input
}
